import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";

interface HostAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};


export default function HostAdd(props:HostAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    const [hostName, setHostName] = useState('');
    const [hostManagementIp, setHostManagementIp] = useState("");
    const [hostSshIp, setHostSshIp] = useState('');
    const [rootPassword, setRootPassword] = useState("");

    const [hostNameWarnYn, setHostNameWarnYn] = useState(false);
    const [hostManagementIpWarnYn, setHostManagementIpWarnYn] = useState(false);
    const [hostSshIpWarnYn, setHostSshIpWarnYn] = useState(false);
    const [rootPasswordWarnYn, setRootPasswordWarnYn] = useState(false);



    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            const successYn = checkHostData();
            if(successYn) {
                setExecuteAddYn(true);
            } else {
                executeResult({successYn: false}, false, '');;
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeAddYn) {
            executeAddHost();
        }
    }, [executeAddYn]);

    function checkHostData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setHostNameWarnYn(false);
        setHostManagementIpWarnYn(false);
        setHostSshIpWarnYn(false);
        setRootPasswordWarnYn(false);
        let message = "";
        let error = false;
        if(!hostName || !hostManagementIp || !hostSshIp || !rootPassword) {
            message = t("MESSAGE_HOST_INFO_ENTER_ERROR_MESSAGE")
            if(!hostName)
                setHostNameWarnYn(true);
            if(!hostManagementIp)
                setHostManagementIpWarnYn(true);
            if(!hostSshIp)
                setHostSshIpWarnYn(true);
            if(!rootPassword)
                setRootPasswordWarnYn(true);
            error = true;
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function executeAddHost() {
        const body = {
            host: {
                host_name: hostName,
                management_ip_address: hostManagementIp,
                ssh_ip_address: hostSshIp,
                root_password: rootPassword
            }
        };

        requests.post(PLATFORM_URL.HOST, body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_HOST_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_HOST_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("HOST_CREATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("HOST_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={hostName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setHostName}
                                warnYn={hostNameWarnYn}
                                placeHolderText={t("HOST_NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("HOST_MANAGEMENT_IP_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={hostManagementIp}
                                type={"text"}
                                activeYn={true}
                                inputCb={setHostManagementIp}
                                warnYn={hostManagementIpWarnYn}
                                placeHolderText={t("HOST_MANAGEMENT_IP_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("HOST_SSH_IP_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={hostSshIp}
                                type={"text"}
                                activeYn={true}
                                inputCb={setHostSshIp}
                                warnYn={hostSshIpWarnYn}
                                placeHolderText={t("HOST_SSH_IP_ENTER_MESSAGE")}
                            />
                        </View>

                        <View style={style.rowContainer}>
                            <CustomText text={t("HOST_ROOT_PASSWORD_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={4}
                                width={250} height={36}
                                value={rootPassword}
                                type={"password"}
                                activeYn={true}
                                inputCb={setRootPassword}
                                warnYn={rootPasswordWarnYn}
                            />
                            {/* <Text style={style.diskUsageText}>
                                {t("UNIT_TEXT")}
                            </Text> */}
                        </View>
                        {/* <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("HOST_GPU_TOTAL_COUNT_DESCRIBE_MESSAGE")}
                        </Text> */}
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },

    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    diskUsageText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowInfoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowStaticText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    dateText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    }
});

const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}



HostAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}